import keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import { fetchFeatureFlags, toggleFeatureFlag, createFeatureFlag, updateFeatureFlag, deleteFeatureFlag } from './feature-flags.utils';

const featureFlags = {
    namespaced: true,
    state: {
        map: {},
        error: null,
    },
    mutations: {
        setMap (state, flags) {
            state.map = keyBy(flags, 'flagName');
        },
        setMapAtKey (state, { id, flag }) {
            state.map[id] = flag;
        },
        removeMapAtKey (state, { id }) {
            delete state.map[id];
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            const flags = await fetchFeatureFlags();
            commit('setMap', flags);
        },
        async createFeatureFlag ({ commit }, { featureFlag }) {
            try {
                commit('setError', { error: null });
                const flag = await createFeatureFlag(featureFlag);
                commit('setMapAtKey', { id: flag.flagName, flag });

                return flag;
            } catch (error) {
                commit('setError', { error });
                console.error(error);
                throw error;
            }
        },
        async updateFeatureFlag ({ commit }, { featureFlag }) {
            try {
                commit('setError', { error: null });
                const flag = await updateFeatureFlag(featureFlag);
                commit('setMapAtKey', { id: flag.flagName, flag });
            } catch (error) {
                commit('setError', { error });
                console.error(error);
                throw error;
            }
        },
        async deleteFeatureFlag ({ commit }, { flagName }) {
            try {
                commit('setError', { error: null });
                await deleteFeatureFlag(flagName);
                commit('removeMapAtKey', { id: flagName });
            } catch (error) {
                commit('setError', { error });
                console.error(error);
                throw error;
            }
        },
        async toggle ({ commit }, { flagName, enabled }) {
            const flag = await toggleFeatureFlag(flagName, enabled);

            commit('setMapAtKey', { id: flagName, flag });
        },
    },
    getters: {
        list: (state) => Object.values(state.map),
    },
};

export default featureFlags;
